<template>
  <div class="creationItem">
    <div style="width:100%;height:120px;display:flex;">
      <v-img v-if="creationInfo.thumbPicture !== ''" :src="creationInfo.thumbPicture" style="width:120px;height:120px;"></v-img>
      <div v-if="creationInfo.thumbPicture === ''" style="width:120px;height:120px;background:#e5e5e5;"></div>
      <div style="width:calc(100% - 120px - 24px);display:flex;flex-direction:column" class="ml-6">
        <div style="flex:1;display:flex;">
          <p style="font-weight:bold;flex:1;white-space:nowrap; text-overflow:ellipsis; overflow:hidden;">{{creationInfo.mainTitle}}</p>
          <v-menu offset-x nudge-right="8" nudge-width="72">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="iconfontFamily">&#xe60e;</span>
            </template>
            <v-list dense>
              <v-list-item-group>
                <v-list-item @click="changePublishStatus(0)" v-if="creationInfo.publicStatus===1">
                  <v-list-item-title>取消公开</v-list-item-title>
                </v-list-item>
                <v-list-item @click="changePublishStatus(1)" v-if="creationInfo.publicStatus===0">
                  <v-list-item-title>公开创作</v-list-item-title>
                </v-list-item>
                <v-list-item @click="saveAsDraft" v-if="creationInfo.progressStatus !== 0">
                  <v-list-item-title>另存草稿</v-list-item-title>
                </v-list-item>
                <v-list-item @click="intoDeleteCreation">
                  <v-list-item-title>删除内容</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </div>

        <div style="flex:1;display:flex;">
          <p style="flex:1;">{{getMainType(creationInfo.mainType)}}</p>
          <p style="font-weight:bold;">{{creationInfo.publicStatus===0 ? "未公开" : "公开"}}</p>
        </div>
        <p style="font-size:14px;">最后编辑时间：{{creationInfo.editTime.slice(0,10)}}</p>
      </div>
    </div>
    <div style="width:100%;height:46px;margin:16px 0;display:flex;align-items: center;">

      <div style="flex:1;text-align:center;">
        <p style="font-size:16px;font-weight:bold;">浏览</p>
        <p style="margin-top:2px;font-size:14px;">{{creationInfo.progressStatus === 0 ? ' - ' : creationInfo.readAmount}}</p>
      </div>
      <div style="width:2px;height:25px;background:rgb(229, 229, 229)"></div>
      <div style="flex:1;text-align:center;">
        <p style="font-size:16px;font-weight:bold;">点赞</p>
        <p style="margin-top:2px;font-size:14px;">{{creationInfo.progressStatus === 0 ? ' - ' : creationInfo.focusAmount}}</p>
      </div>
      <div style="width:2px;height:25px;background:rgb(229, 229, 229)"></div>
      <div style="flex:1;text-align:center;">
        <p style="font-size:16px;font-weight:bold;">评论</p>
        <p style="margin-top:2px;font-size:14px;">{{creationInfo.progressStatus === 0 ? ' - ' : creationInfo.commentAmount}}</p>
      </div>
      <div style="width:2px;height:25px;background:rgb(229, 229, 229)"></div>
      <div style="flex:1;text-align:center;">
        <p style="font-size:16px;font-weight:bold;">转发</p>
        <p style="margin-top:2px;font-size:14px;">{{creationInfo.progressStatus === 0 ? ' - ' : creationInfo.shareAmount}}</p>
      </div>

    </div>
    <div style="width:100%;height:20px;margin:16px 0;display:flex;">
      <p style="flex:1;" :style="{'color':getProgressStatusColor(creationInfo.progressStatus)}">
        <span class="iconfontFamily mr-1">&#xe61d;</span>
        {{getProgressStatus(creationInfo.progressStatus)}}
        <span @click="intoErrorCreationDialog" v-if="creationInfo.progressStatus === 3 || creationInfo.progressStatus === 4"
              style="text-decoration:underline;cursor:pointer;" class="ml-1">查看详情</span>
      </p>
      <v-spacer></v-spacer>
      <p @click="intoEditCreationPage" style="color:#1976D2;cursor:pointer;"><span class="iconfontFamily mr-1">&#xe606;</span>编辑</p>
    </div>
    <v-snackbar v-model="snackbar_saveAsDraft" tile elevation="0" color="#4CAF50" width="840" height="30" timeout="1000" absolute class="creationItem_saveAsDraftSnackbar">另存为草稿成功</v-snackbar>

    <!--错误内容弹窗-->
    <error-creation-dialog :dialogShow="errorCreationDialogShow" :errorStatus="creationInfo.progressStatus" :creationTitle="creationInfo.mainTitle" @hideErrorCreationDialog="hideErrorCreationDialog"></error-creation-dialog>

    <!--编辑内容弹窗-->
    <edit-creation-dialog :dialogShow="editCreationDialogShow" @hideEditCreationDialog="hideEditCreationDialog"></edit-creation-dialog>

    <!--删除内容弹窗-->
    <delete-creation-dialog :dialogShow="deleteCreationDialogShow" @hideDeleteCreationDialog="hideDeleteCreationDialog" @deleteOKFun="deleteOKFun"></delete-creation-dialog>


  </div>

</template>

<script>
import ErrorCreationDialog from '/src/components/creation_item/dialog/ErrorCreationDialog';
import EditCreationDialog from '/src/components/creation_item/dialog/EditCreationDialog';
import DeleteCreationDialog from '/src/components/creation_item/dialog/DeleteCreationDialog';
export default {
  name: "CreationItem",
  components: {
    ErrorCreationDialog,EditCreationDialog,DeleteCreationDialog
  },
  props:["creationInfo"],
  data(){
    return{

      //删除
      deleteCreationId:"",

      //另存草稿成功
      snackbar_saveAsDraft:false,

      //稿件错误弹窗
      errorCreationDialogShow:false,
      //编辑内容弹窗
      editCreationDialogShow:false,
      //删除内容弹窗
      deleteCreationDialogShow:false,

    }



  },
  computed:{
    getMainType(){
      return function(mainType){
        switch(mainType){
          case 1:{
            return "长图文创作"
          }
          case 3:{
            return "视频创作"
          }

        }
      }
    },
    getProgressStatus(){
      return function(progressStatus){
        switch(progressStatus){
          case 1:{
            return "已发布"
          }
          case 0:{
            return "草稿"
          }
          case 2:{
            return "审核中"
          }
          case 3:{
            return "未通过"
          }
          case 4:{
            return "已下架"
          }


        }

      }
    },
    getProgressStatusColor(){
      return function(progressStatus){
        switch(progressStatus){
          case 1:{
            return "#4CAF50"
          }
          case 0:{
            return "#000000"
          }
          case 2:{
            return "#1976D2"
          }
          case 3:{
            return "#FFC300"
          }
          case 4:{
            return "#FF0000"
          }


        }

      }
    },
  },
  methods:{
    //编辑
    intoEditCreationPage(){

      if(this.creationInfo.progressStatus === 0){
        //是草稿
        switch(this.creationInfo.mainType){
          case 1:{
            let route = this.$router.resolve({
              path: "/createArticle",
              query: {
                creationId:this.creationInfo.infoId
              }
            });
            window.open(route.href, '_blank');
            break;
          }
          case 3:{
            let route = this.$router.resolve({
              path: "/createVideo",
              query: {
                creationId:this.creationInfo.infoId
              }
            });
            window.open(route.href, '_blank');
            break;
          }
        }
      }
      else{
        //不是草稿，展示弹窗
        this.$store.state.editCreationInfo = {
          mainType:this.creationInfo.mainType,
          infoId:this.creationInfo.infoId
        };
        this.editCreationDialogShow = true;
      }
    },



    //公开/取消公开
    changePublishStatus(status){
      let data = new FormData();
      data.append('infoId',this.creationInfo.infoId);
      data.append('publicStatus',status);
      this.$axios({
        method:"post",
        url:"/authorApi/main-info/publicMainInfo",
        data:data
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.creationInfo.publicStatus = status
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });

    },

    //另存草稿
    saveAsDraft(){
      let param = new FormData();
      param.append('mainType',this.creationInfo.mainType);
      param.append('mainTitle',this.creationInfo.mainTitle);
      param.append('bubblePicture',this.creationInfo.bubblePicture);
      param.append('context',this.creationInfo.context);   //视频内容和简介相同
      param.append('thumbPicture',this.creationInfo.thumbPicture);
      param.append('picture1',this.creationInfo.picture1);
      param.append('simpleInfo',this.creationInfo.simpleInfo);
      param.append('geo',this.creationInfo.geo);
      param.append('geoName',this.creationInfo.geoName);
      param.append('publicStatus',this.creationInfo.publicStatus);
      param.append('progressStatus',0);

      this.$axios({
        method:"post",
        url:"/authorApi/main-info/editMainInfo",
        data:param
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.snackbar_saveAsDraft = true;
          setTimeout(()=>{
            let nreCreationInfo = JSON.parse(JSON.stringify(this.creationInfo))
            nreCreationInfo.infoId = resultData.data;
            nreCreationInfo.progressStatus = 0;
            this.$emit("saveAsDraftSuccess",nreCreationInfo)
          },1000)
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });






    },

    //删除弹窗
    intoDeleteCreation(){
      this.$store.state.deleteCreationId = this.creationInfo.infoId;
      this.deleteCreationDialogShow = true;
    },
    //近期创作删除成功
    deleteOKFun(){
      this.$emit("deleteOKFun")
    },

    //进入稿件有误弹窗
    intoErrorCreationDialog(){
      this.errorCreationDialogShow = true;
    },
    //隐藏稿件有误弹窗
    hideErrorCreationDialog(){
      this.errorCreationDialogShow = false;
    },
    //隐藏编辑内容弹窗
    hideEditCreationDialog(){
      this.editCreationDialogShow = false;
    },
    //隐藏删除内容弹窗
    hideDeleteCreationDialog(){
      this.deleteCreationDialogShow = false;
    },


  }




}
</script>

<style scoped>
.creationItem{
  position:relative;
  width:400px;
  height:264px;
  background:#ffffff;
  padding:24px;
  /*border-bottom:1px solid #E5E5E5;*/
  border-radius:4px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
}

</style>

<style>
.creationItem_saveAsDraftSnackbar .v-snack__wrapper{
  min-height:0;
  max-width:100%;
  margin:0;
  position:absolute;
  top:0;
}
.creationItem_saveAsDraftSnackbar .v-snack__content{
  padding:0;
  text-align:center;
}

</style>